const items = [
  "التحول الرقمي",
  "الذكاء الاصطناعي",
  "منصة رواج الذكية",
  "حلول المدفوعات",
  "الأمن السيبراني",
  "استشارات PMO",
  "منصات SaaS",
  "BRAH-TECH.COM",
];

export const Marquee = () => (
  <section className="relative py-6 border-y border-[#D4AF37]/20 bg-[#0F1A36] overflow-hidden" data-testid="marquee-section">
    <div className="marquee-track" dir="ltr">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0 items-center">
          {items.map((item, i) => (
            <span key={`${dup}-${i}`} className="flex items-center shrink-0">
              <span
                className={`font-display text-lg sm:text-xl tracking-wide px-8 ${
                  /^[A-Z]/.test(item) ? "font-mono-tech text-sm sm:text-base text-[#94A3B8]" : "text-[#E5C158]"
                }`}
              >
                {item}
              </span>
              <span className="w-2 h-2 rounded-full bg-[#D4AF37]/60 shrink-0" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
